// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteHourStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("State ID"),
});

export const deleteHourStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State deleted
 */
export const deleteHourState200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteHourState401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Cannot delete system-managed state
 */
export const deleteHourState403Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description State not found
 */
export const deleteHourState404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteHourStateMutationResponseSchema = z.lazy(() => deleteHourState200Schema);
